// Saldo über mehrere Monate laden (13.10.2026, Mandant 3: „Dashboard kann nicht geladen werden“): Die Schnittstelle
// GET saldo?from_month&from_year&to_month&to_year brauchte bei großen Mandanten für Januar bis Oktober über 20 s bzw.
// lief in das 29-s-Limit des API Gateway (Antwort ohne CORS-Kopf, im Browser Status 0). Sie liefert Zeilen je Fahrer,
// Tag und Abrechnungsmonat ohne monatsübergreifende Werte (bconn-saldo-get); dieselben Zeilen kommen deshalb auch über
// eine Anfrage je Monat. loadSaldoMonths lädt den Bereich so – höchstens MAX_PARALLEL Monate gleichzeitig, ein
// fehlgeschlagener Monat wird einmal wiederholt (nicht bei 403) – und gibt alle Zeilen in Monatsreihenfolge zurück.
// Scheitert ein Monat endgültig, wird das Promise mit dessen Fehler abgelehnt.
import axios from 'axios';

const MAX_PARALLEL = 6;

// Monate von (fromYear, fromMonth) bis (toYear, toMonth) einschließlich als [{ year, month }]
export function monthRange(fromYear, fromMonth, toYear, toMonth) {
  const out = [];
  let y = Number(fromYear);
  let m = Number(fromMonth);
  const endY = Number(toYear);
  const endM = Number(toMonth);
  while (y < endY || (y === endY && m <= endM)) {
    out.push({ year: y, month: m });
    m += 1;
    if (m > 12) {
      m = 1;
      y += 1;
    }
    if (out.length > 240) {
      break;
    }
  }
  return out;
}

function status(error) {
  return error && error.response ? error.response.status : null;
}

export function loadSaldoMonths(baseUrl, fromYear, fromMonth, toYear, toMonth) {
  const months = monthRange(fromYear, fromMonth, toYear, toMonth);
  const url = ({ year, month }) =>
    `${baseUrl}saldo?from_month=${month}&from_year=${year}&to_month=${month}&to_year=${year}`;
  const loadOne = (entry) => axios.get(url(entry)).catch((error) => (
    status(error) === 403 ? Promise.reject(error) : axios.get(url(entry))
  ));
  const results = new Array(months.length);
  let next = 0;
  const worker = () => {
    if (next >= months.length) {
      return Promise.resolve();
    }
    const index = next;
    next += 1;
    return loadOne(months[index]).then((response) => {
      results[index] = Array.isArray(response.data) ? response.data : [];
      return worker();
    });
  };
  const workers = [];
  for (let i = 0; i < Math.min(MAX_PARALLEL, months.length); i += 1) {
    workers.push(worker());
  }
  return Promise.all(workers).then(() => results.reduce((all, rows) => all.concat(rows || []), []));
}
